import { Controller } from '@hotwired/stimulus';
import Overlay from '../../../libs/cifra/overlay';

/* global $ */
export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.input-activar-ruta').forEach((input) => {
      input.addEventListener('change', () => {
        const card = input.closest('.card-ruta');
        this.#activarDesactivarRuta(card, input.checked);
      });
    });
    document.getElementById('btn-clonar').addEventListener('click', () => {
      const form = document.getElementById('form-clonacion');
      const $form = $(form);
      const overlay = new Overlay(this.element);

      overlay.show();
      $form.one('ajax:complete', () => {
        overlay.hide();
      });
      $.rails.handleRemote($form);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  #activarDesactivarRuta(rutaCard, marcado) {
    const body = rutaCard.querySelector('.card-body');
    if (marcado) {
      const overlay = body.querySelector('.overlay-manual');
      if (overlay) {
        overlay.remove();
      }
    } else {
      body.style.position = 'relative';
      const overlay = '<span class="overlay-manual"></span>';
      body.insertAdjacentHTML('beforeend', overlay);
    }
  }
}
